// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3UysH","actions":"GroupTable_actions__1iEQy","deleteModalFooter":"GroupTable_deleteModalFooter__3XJVe"};